export const TRAINING_CALORIE_REFERENCE_LEAN_MASS_KG = 60;

const REST_FACTOR_BREAKPOINTS: { maxSeconds: number; factor: number }[] = [
    { maxSeconds: 30, factor: 1.15 },
    { maxSeconds: 60, factor: 1.05 },
    { maxSeconds: 90, factor: 1.0 },
    { maxSeconds: 150, factor: 0.95 },
];
const REST_FACTOR_LONG_REST = 0.9;

export function trainingRestFactor(restSeconds: number): number {
    for (const breakpoint of REST_FACTOR_BREAKPOINTS) {
        if (restSeconds <= breakpoint.maxSeconds) return breakpoint.factor;
    }
    return REST_FACTOR_LONG_REST;
}

export function trainingLeanMassFactor(leanMassKg: number | null | undefined): number {
    if (leanMassKg == null || !Number.isFinite(leanMassKg) || leanMassKg <= 0) return 1;
    return leanMassKg / TRAINING_CALORIE_REFERENCE_LEAN_MASS_KG;
}

export type TrainingExerciseCalorieInputs = {
    baseMet: number;
    exerciseFactor: number;
    restSeconds: number;
    bodyWeightKg: number;
    leanMassKg?: number | null;
};

export function trainingEffectiveMet(inputs: Omit<TrainingExerciseCalorieInputs, 'bodyWeightKg'>): number {
    return inputs.baseMet * inputs.exerciseFactor * trainingRestFactor(inputs.restSeconds) * trainingLeanMassFactor(inputs.leanMassKg);
}

export function trainingKcalPerMinute(inputs: TrainingExerciseCalorieInputs): number {
    if (inputs.bodyWeightKg <= 0) return 0;
    return (trainingEffectiveMet(inputs) * 3.5 * inputs.bodyWeightKg) / 200;
}
